import {
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FitterCommentsSheetComponent } from '@sc/ui-components';
import { ScreenUtils } from '@sc/utils';
import { FitterCommentsInputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-fitter-comments-dialog',
  styleUrls: ['./fitter-comments-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FitterCommentsSheetComponent],
  template: `
    <sc-fitter-comments-sheet
      [fitter]="data.fitter"
      [itineraryDistanceInMeters]="data.itineraryDistanceInMeters"
      [itineraryDurationInSeconds]="data.itineraryDurationInSeconds"
      (closeEvent)="onCloseSheet()"
    ></sc-fitter-comments-sheet>
  `,
})
export class FitterCommentsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FitterCommentsInputData,
    private readonly dialogRef: MatDialogRef<FitterCommentsDialogComponent>
  ) {}

  onCloseSheet() {
    this.dialogRef.close();
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    if (!ScreenUtils.isDesktopResolution()) {
      this.onCloseSheet();
    }
  }
}
